var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEwinMarksixSchedule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/40x40px/eWin-index/M6/schedule") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/40x40px/eWin-index/M6/schedule"
  }, /*#__PURE__*/React.createElement("g", {
    id: "draw-schedule",
    transform: "translate(0.000000, 3.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0000667,30.0938507 C40.0000667,31.5263047 31.0460517,32.6877013 20.0000333,32.6877013 C8.95468159,32.6877013 0,31.5263047 0,30.0938507 C0,28.6613966 8.95468159,27.5 20.0000333,27.5 C31.0460517,27.5 40.0000667,28.6613966 40.0000667,30.0938507",
    id: "Fill-7",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2ECEC",
    fillRule: "nonzero",
    x: 3.5,
    y: 0,
    width: 33,
    height: 30,
    rx: 3.3402
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5,3.00900901 L36.5,6 L3.5,6 L3.5,3.00900901 C3.50292568,1.34839259 4.84839259,0.00292567887 6.50900901,0 L33.490991,0 C35.1516074,0.00292567887 36.4970743,1.34839259 36.5,3.00900901 L36.5,3.00900901 Z",
    id: "Path",
    fill: "#980B0B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CB7B7B",
    fillRule: "nonzero",
    x: 13.5,
    y: 10.5,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFC600",
    fillRule: "nonzero",
    x: 19.5,
    y: 10.5,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CB7B7B",
    fillRule: "nonzero",
    x: 25.5,
    y: 10.5,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CB7B7B",
    fillRule: "nonzero",
    x: 7.5,
    y: 16.5,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CB7B7B",
    fillRule: "nonzero",
    x: 13.5,
    y: 16.5,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CB7B7B",
    fillRule: "nonzero",
    x: 19.5,
    y: 16.5,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CB7B7B",
    fillRule: "nonzero",
    x: 25.5,
    y: 16.5,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CB7B7B",
    fillRule: "nonzero",
    x: 7.5,
    y: 22.5,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFC600",
    fillRule: "nonzero",
    x: 13.5,
    y: 22.5,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CB7B7B",
    fillRule: "nonzero",
    x: 19.5,
    y: 22.5,
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(25.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CB7B7B",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 7,
    cy: 7,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59912587,6.5858781 C8.47228475,6.41118916 8.30022765,6.26387057 8.09628232,6.15533381 C7.88359325,6.04659103 7.63942391,5.99148526 7.39183227,5.99634882 C7.18680238,5.99363153 6.9838057,6.0314975 6.79863801,6.10700027 C6.62306305,6.18033576 6.46688613,6.28373317 6.33974611,6.41081107 C6.36544353,6.20271179 6.42553078,5.9988009 6.51820407,5.80519974 C6.59868276,5.63680175 6.71497192,5.48268804 6.86114928,5.35070718 C7.00382829,5.22475524 7.17705774,5.12721545 7.36858175,5.06498869 C7.58504742,4.99649962 7.81448213,4.96309799 8.04519236,4.96648617 L8.11015106,4.96648617 L8.11015106,4.00042729 L7.93403854,4.00042729 C7.50112025,3.99336184 7.07237255,4.07400801 6.68269132,4.23580199 C6.32015837,4.39120805 6.00510994,4.61720113 5.76276603,4.89569022 C5.50138244,5.20111009 5.30881676,5.54566688 5.19496378,5.91165588 C5.06055342,6.33650054 4.99504732,6.77518648 5.00029164,7.21535029 L5.00029164,7.66599713 C4.99647413,7.98659192 5.04403111,8.30611798 5.14163035,8.61562436 C5.2236967,8.88071677 5.3611002,9.13087896 5.54718881,9.35399996 C5.71485585,9.55290207 5.93370746,9.71604341 6.18678214,9.83078013 C6.44748882,9.94558736 6.73715421,10.0036398 7.03022545,9.9998164 C7.58784592,10.00717 8.11814628,9.79328477 8.466965,9.42033839 C8.6432308,9.23039622 8.77680668,9.01404879 8.8608982,8.78230077 C8.95566301,8.5253191 9.00256982,8.25713995 8.99989146,7.98763802 C9.0015218,7.7290189 8.96808745,7.47111319 8.90026093,7.21910859 C8.84205563,6.99504314 8.7402547,6.7809749 8.59912587,6.5858781 Z M7.64911766,8.42263983 C7.62184848,8.53914293 7.57499502,8.65163705 7.51002243,8.75660446 C7.45718237,8.84315433 7.38190022,8.91817256 7.28995827,8.97589712 C7.20367134,9.0281087 7.100354,9.05563785 6.99473781,9.05455929 C6.77523626,9.04296342 6.58327751,8.92379132 6.50198989,8.74865084 C6.35542434,8.45707311 6.29036824,8.14017861 6.31200864,7.82323408 L6.31200864,7.59415235 C6.30941408,7.40001711 6.39944182,7.21339561 6.56123793,7.07751668 L6.56460314,7.07480721 C6.67780933,6.98347146 6.82861863,6.93428911 6.98403034,6.93802243 C7.08778359,6.93767573 7.18905918,6.96518344 7.27364211,7.0166846 C7.36743022,7.07439497 7.44501489,7.14931224 7.50074261,7.23597726 C7.56897982,7.34098819 7.61821755,7.45427096 7.64677221,7.57195214 C7.68200273,7.71268003 7.69910114,7.8562976 7.6977602,8.00022397 C7.69906521,8.14205131 7.68275925,8.2835951 7.64911766,8.42246503 L7.64911766,8.42263983 Z",
    id: "Shape",
    fill: "#CB7B7B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3387055,4 C12.5059561,3.81407566 11.7811891,3.43350014 11.1644046,2.85827344 C10.5476201,2.28304674 10.1617899,1.55239976 10.0069141,0.666332505 C10.8645034,1.10041547 12.3336535,1.9423553 13.3387055,4 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3387055,13.3226023 C12.5046117,13.1263865 11.7791725,12.7406653 11.1623879,12.1654386 C10.5456034,11.5902119 10.1602918,10.8628376 10.0064532,9.98331565 C10.8640424,10.38372 12.3759677,11.3059179 13.3387055,13.3226023 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(11.672579, 11.652959) scale(1, -1) translate(-11.672579, -11.652959) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99823132,13.3263724 C3.15485222,13.1113383 2.42477041,12.7162079 1.80798588,12.1409812 C1.19120135,11.5657545 0.811872726,10.8465327 0.67,9.98331565 C1.52760106,10.38372 3.07897169,11.3317317 3.99823132,13.3263724 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(2.334116, 11.654844) scale(-1, -1) translate(-2.334116, -11.654844) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0017938,4.00002466 C3.19791065,3.80369845 2.48757682,3.417922 1.87079229,2.8426953 C1.25400776,2.2674686 0.85374366,1.54201433 0.67,0.666332505 C1.55590382,1.11467106 2.99674179,1.9423553 4.0017938,4.00002466 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(2.335897, 2.333179) scale(-1, 1) translate(-2.335897, -2.333179) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEwinMarksixSchedule);
export default __webpack_public_path__ + "static/media/ewin_marksix_schedule.b64946f0cadd7c02c47dbbebeb5df577.svg";
export { ForwardRef as ReactComponent };